/** Auto-generated by import-constants plugin. Do not edit manually */

export const optionalImportEntrypoints: string[] = [
  "langchain/agents/load",
  "langchain/agents/toolkits/sql",
  "langchain/tools/sql",
  "langchain/tools/webbrowser",
  "langchain/chains/load",
  "langchain/chains/query_constructor",
  "langchain/chains/query_constructor/ir",
  "langchain/chains/sql_db",
  "langchain/chains/graph_qa/cypher",
  "langchain/chat_models/universal",
  "langchain/document_loaders/fs/buffer",
  "langchain/document_loaders/fs/directory",
  "langchain/document_loaders/fs/json",
  "langchain/document_loaders/fs/multi_file",
  "langchain/document_loaders/fs/text",
  "langchain/sql_db",
  "langchain/output_parsers/expression",
  "langchain/retrievers/self_query",
  "langchain/retrievers/self_query/functional",
  "langchain/cache/file_system",
  "langchain/stores/file/node",
  "langchain/storage/file_system",
  "langchain/hub",
  "langchain/hub/node",
];
